var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRosgosstrakhBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rosgosstrakh_Bank"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 444704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.35 13.05V12H3.8V10.75H0V17.35H3.15L4.1 16.4V14.05L3.1 13.1C3.1 13.05 1.35 13.05 1.35 13.05ZM2.7 16.05H1.35V14.3H2.7V16.05ZM5.85 10.7L4.5 17.3H5.85L6.15 15.75H7.9L8.2 17.3H9.55L8.2 10.7H5.85ZM6.4 14.5L6.9 12H7.15L7.65 14.5H6.4ZM13.15 13.4H11.5V10.7H10.15V17.3H11.5V14.7H13.15V17.3H14.5V10.7H13.15V13.4ZM18.8 13.95L19.95 10.7H18.55L17.65 13.3H16.9V10.7H15.5V17.3H16.9V14.6H17.6L18.55 17.3H20L18.8 13.95Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.85005 9.6H6.20005V4.25H7.95005V3H4.85005V9.6ZM0.0500488 3V9.6H1.40005V7.95H3.15005L4.15005 7V4L3.15005 3H0.0500488ZM2.75005 6.65H1.35005V4.25H2.70005V6.65H2.75005ZM9.70005 4.25H11.65V3H9.30005L8.35005 3.95V8.65L9.30005 9.6H11.65V8.3H9.70005V4.25Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRosgosstrakhBank);
export default __webpack_public_path__ + "static/media/rosgosstrakh_bank.38f9553509a66e2ba0a9bf7e9c9a0ac6.svg";
export { ForwardRef as ReactComponent };